const cloud = {
    self_hosted_licenses: {
        title: 'تراخيص الاستضافة الذاتية',
        description: 'اعرض التراخيص المملوكة لحسابك وانسخ المفاتيح لعمليات النشر ذاتية الاستضافة.',
        empty_title: 'لا توجد تراخيص استضافة ذاتية بعد',
        empty_description: 'إذا اشتريت ترخيصًا، فتأكد من تسجيل الدخول بالحساب الذي استخدمته لشرائه.',
        load_error: 'تعذر تحميل التراخيص. يرجى المحاولة مرة أخرى.',
        period_end: 'نهاية الفترة الحالية',
        keys_title: 'مفاتيح الترخيص',
        keys_description: 'حافظ على سرية هذه المفاتيح. استخدم المفتاح المناسب لبيئة النشر.',
        production_key: 'مفتاح الإنتاج',
        non_production_key: 'مفتاح غير الإنتاج',
        keys_unavailable: 'مفاتيح هذا الترخيص غير متاحة. تواصل مع الدعم إذا كنت بحاجة إلى مساعدة.',
        issue_keys: 'الحصول على مفاتيح الترخيص',
        issue_error: 'تعذر إصدار مفاتيح الترخيص. يرجى المحاولة مرة أخرى.',
        install_title: 'تثبيت الترخيص',
        install_description: 'يوفر كلا المفتاحين الميزات والحصص نفسها. ما لم ينص نموذج طلبك على خلاف ذلك، يغطي اشتراكك عملية نشر واحدة للإنتاج.',
        install_copy: 'انسخ مفتاح الإنتاج لبيئة الإنتاج، أو مفتاح غير الإنتاج للتطوير والاختبار.',
        install_paste: 'في وحدة التحكم ذاتية الاستضافة، افتح الإعدادات ← الترخيص، والصق المفتاح ثم ثبّته.',
        status: {
            active: 'نشط',
            past_due: 'متأخر الدفع',
            canceling: 'يُلغى في نهاية الفترة',
            canceled: 'ملغى',
            unpaid: 'غير مدفوع',
            expired: 'منتهي الصلاحية',
            revoked: 'مسحوب',
        },
    },
    console_sso: {
        back_to_list: 'العودة إلى تسجيل الدخول الموحد لوحدة التحكم',
        create: 'إضافة موصل',
        title: 'تسجيل الدخول الموحّد لوحدة التحكم',
        description: 'قم بتكوين موفّر الهوية الخاص بك لتسجيل الدخول إلى Logto Console باستخدام تسجيل الدخول الموحّد.',
        domain_bound: 'مرتبط',
        domain_pending: 'جارٍ التحقق',
        domain_verify_step: 'تحقق من نطاقك',
        domain_bind_step: 'ربط نطاق البريد الإلكتروني',
        domain_add_placeholder: 'إضافة نطاق بريد إلكتروني',
        domain_bound_description: 'هذا النطاق نشط لتسجيل الدخول الموحد إلى Console. تمت إزالة سجل TXT الخاص بالتحقق.',
        domain_dns_instructions: 'أضف سجل TXT هذا لدى مزود DNS للتحقق من ملكية النطاق.',
        domain_waiting_for_dns: 'بانتظار سجل TXT. نتحقق مرة أخرى كل 10 ثوانٍ.',
        domain_proven_unbound: 'تم التحقق من ملكية النطاق، لكن الربط لم يكتمل.',
        domain_verified: 'تم التحقق من ملكية النطاق.',
        domain_binding_pending: 'يبدأ الربط تلقائيًا بعد التحقق.',
        domain_remove_description: 'هل تريد إزالة {{domain}} من Console SSO؟ ستؤدي إزالة نطاق مرتبط إلى إيقاف اكتشاف SSO لعناوين البريد الإلكتروني الخاصة به.',
        domain_invalid: 'أدخل نطاق بريد إلكتروني صالحًا.',
        domain_conflict: 'هذا النطاق مرتبط بالفعل بموصل Console SSO آخر.',
        domain_invalid_provider: 'أكمل إعدادات الاتصال قبل ربط هذا النطاق.',
        domain_dns_timeout: 'فشل التحقق من DNS. سنعيد المحاولة تلقائيًا.',
        domain_recovery: 'لم يكتمل تغيير النطاق.',
        start_over: 'البدء من جديد',
        start_over_confirmation: 'قد تؤدي إعادة البدء إلى حذف إعداد SSO غير المكتمل. هل تريد المتابعة؟',
        resume_creation: 'تم العثور على عملية إنشاء غير مكتملة. تابع باستخدام الموفر نفسه لاستعادة هذا الموصل.',
    },
    general: {
        onboarding: 'عملية التسجيل',
    },
    create_tenant: {
        page_title: 'إنشاء مستأجر',
        title: 'أنشئ أول مستأجر لك',
        description: 'المستأجر هو بيئة معزولة حيث يمكنك إدارة هويات المستخدمين والتطبيقات وجميع الموارد الأخرى في Logto.',
        invite_collaborators: 'ادعو مشاركيك عبر البريد الإلكتروني',
        hear_about_us: {
            title: 'كيف سمعت عن Logto لأول مرة؟',
            detail_placeholder: 'أخبرنا المزيد (اختياري)',
            options: {
                search_engine: 'محرك بحث (Google، Bing...)',
                ai_assistant: 'مساعد ذكاء اصطناعي (ChatGPT، Claude، Gemini...)',
                github_oss: 'GitHub أو أدلة المصادر المفتوحة',
                friend_colleague: 'صديق أو زميل',
                powered_by: 'صفحة تسجيل الدخول لتطبيق يستخدم Logto',
                content_social: 'وسائل التواصل الاجتماعي أو مقال أو فيديو (YouTube، X، Reddit...)',
                other: 'أخرى',
            },
        },
    },
    social_callback: {
        title: 'لقد قمت بتسجيل الدخول بنجاح',
        description: 'لقد قمت بتسجيل الدخول بنجاح باستخدام حسابك الاجتماعي. لضمان التكامل السلس والوصول إلى جميع ميزات Logto، نوصي بمتابعة تكوين موصلك الاجتماعي الخاص بك.',
        notice: 'يرجى تجنب استخدام الموصل التجريبي لأغراض الإنتاج. بمجرد الانتهاء من الاختبار، نرجو حذف الموصل التجريبي وإعداد موصلك الخاص باستخدام بيانات الاعتماد الخاصة بك.',
    },
    tenant: {
        create_tenant: 'إنشاء مستأجر',
    },
};
export default Object.freeze(cloud);
